import { render, staticRenderFns } from "./easyQuestion.vue?vue&type=template&id=2b646fc8&lang=pug"
import script from "./easyQuestion.vue?vue&type=script&lang=js"
export * from "./easyQuestion.vue?vue&type=script&lang=js"
import style0 from "./easyQuestion.vue?vue&type=style&index=0&id=2b646fc8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports